var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1518,
    height: 493,
    viewBox: "0 0 1518 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7234 29.5C16.8901 23 33.2235 6 35.7235 6H1472.22C1476.56 6 1491.56 18.5 1493.22 23.5L1493.29 23.697C1494.29 26.6949 1495.76 31.0975 1495.72 35.5C1494.72 163.5 1494.32 432 1490.72 448C1489.49 453.5 1490.72 461.431 1480.22 461.5C1001.39 464.667 47.5454 461.5 35.2231 461.5C21.7231 461.5 19.723 459.5 18.7233 450C15.6594 420.886 12.5568 36 14.7234 29.5Z",
    fill: "url(#paint0_linear_101_2)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.281 12.8872C802.362 12.9275 802.431 12.9653 802.491 13C802.431 13.0347 802.362 13.0725 802.281 13.1128C801.73 13.3879 800.853 13.6809 799.638 13.9741C797.224 14.5566 793.688 15.0899 789.27 15.5407C780.446 16.4411 768.231 17 754.723 17C741.215 17 729 16.4411 720.176 15.5407C715.758 15.0899 712.222 14.5566 709.808 13.9741C708.593 13.6809 707.717 13.3879 707.165 13.1128C707.084 13.0725 707.015 13.0347 706.955 13C707.015 12.9653 707.084 12.9275 707.165 12.8872C707.717 12.6121 708.593 12.3191 709.808 12.0259C712.222 11.4434 715.758 10.9101 720.176 10.4593C729 9.55889 741.215 9 754.723 9C768.231 9 780.446 9.55889 789.27 10.4593C793.688 10.9101 797.224 11.4434 799.638 12.0259C800.853 12.3191 801.73 12.6121 802.281 12.8872Z",
    stroke: "url(#paint1_linear_101_2)",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.723 9L262.723 12.5L279.723 18",
    stroke: "url(#paint2_linear_101_2)",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1224.72 9L1245.72 12.5L1228.72 18",
    stroke: "url(#paint3_linear_101_2)",
    strokeWidth: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_df_101_2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 987.648,
    y1: 7.61925,
    x2: 994.648,
    y2: 24.6192,
    stroke: "#343434",
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_df_101_2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 993.572,
    y1: 7.2385,
    x2: 1000.57,
    y2: 24.2385,
    stroke: "#343434",
    strokeWidth: 4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_df_101_2)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 18.3848,
    y2: -1,
    transform: "matrix(-0.38075 0.924678 0.924678 0.38075 522.723 8)",
    stroke: "#343434",
    strokeWidth: 2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_df_101_2)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 18.3848,
    y2: -2,
    transform: "matrix(-0.38075 0.924678 0.924678 0.38075 517.723 8)",
    stroke: "#343434",
    strokeWidth: 4
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_df_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.723 7C46.723 7 29.6695 23 28.2231 27.5C23.7232 41.5 29.223 430 30.7231 442C32.4732 456 34.723 461 34.723 461",
    stroke: "url(#paint4_linear_101_2)",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_df_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1462.72 7C1462.72 7 1479.78 23 1481.22 27.5C1485.72 41.5 1480.22 430 1478.72 442C1476.97 456 1474.72 461 1474.72 461",
    stroke: "url(#paint5_linear_101_2)",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_2",
    x: -4.88303e-8,
    y: 0,
    width: 1517.72,
    height: 492.907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_101_2",
    x: 704.723,
    y: 7,
    width: 100,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_101_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_101_2",
    x: 261.415,
    y: 7.01361,
    width: 23.4722,
    height: 12.9378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_101_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_101_2",
    x: 1223.56,
    y: 7.01361,
    width: 23.4723,
    height: 12.9378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_101_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_df_101_2",
    x: 984.723,
    y: 3.2385,
    width: 16.8494,
    height: 25.7615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.541667 0 0 0 0 0.541667 0 0 0 0 0.541667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_101_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_df_101_2",
    x: 989.723,
    y: 2.477,
    width: 18.6987,
    height: 26.523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_101_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_df_101_2",
    x: 511.874,
    y: 3.2385,
    width: 16.8494,
    height: 25.7615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_101_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_df_101_2",
    x: 505.024,
    y: 2.477,
    width: 18.6987,
    height: 26.523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.541667 0 0 0 0 0.541667 0 0 0 0 0.541667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_101_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_df_101_2",
    x: 23.9878,
    y: 3.27097,
    width: 28.4193,
    height: 461.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect2_foregroundBlur_101_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_df_101_2",
    x: 1457.04,
    y: 3.27097,
    width: 28.4193,
    height: 461.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect2_foregroundBlur_101_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_2",
    x1: 754.862,
    y1: 6,
    x2: 754.862,
    y2: 461.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156296,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.030213,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0456329,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0805845,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131984,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158198,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197775,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919254,
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966961,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040404"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_2",
    x1: 706.723,
    y1: 13,
    x2: 803.723,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499849,
    stopColor: "#252525",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_2",
    x1: 262.937,
    y1: 13.5,
    x2: 283.723,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_2",
    x1: 1245.51,
    y1: 13.5,
    x2: 1224.72,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_101_2",
    x1: 30.8965,
    y1: 233.999,
    x2: 47.723,
    y2: 233.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_101_2",
    x1: 1478.55,
    y1: 233.999,
    x2: 1461.72,
    y2: 233.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525",
    stopOpacity: 0.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.94eeee6dfa69ccfbd88695ed9e4a951d.svg";
export { ForwardRef as ReactComponent };